import * as VueRouter from 'vue-router';

import Home from '@/views/Home.vue'
import Index from '@/views/Index.vue'
import Project from '@/views/Project.vue'
import Information from '@/views/Information.vue'
import Diary from '@/views/Diary.vue'
import Error from '@/views/Error.vue'

const routes = [
  { path: '/home', redirect: '/' },
  { name: 'Home', path: '/', component: Home },
  { name: 'Index', path: '/index', component: Index },
  { name: 'Project', path: '/index/:project', component: Project },
  { name: 'Information', path: '/information', component: Information },
  { name: 'Diary', path: '/diary', component: Diary },
  { name: 'DiaryEntry', path: '/diary/:slug', component: Diary },
  { name: 'Error', path: '/:pathMatch(.*)*', component: Error },
]

export const router = VueRouter.createRouter({
  history: VueRouter.createWebHistory(),
  routes: routes,
  scrollBehavior: function (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' };
    } else {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 100);
    }
  }
})
